// src/components/Layout.js
import React from 'react';
import './Layout.css';

const Layout = ({ children, title, icon, headerActions, className = '' }) => {
  return (
    <div className={`layout-container ${className}`}>
      <div className="layout-content">
        {children}
      </div>
    </div>
  );
};

export default Layout;
